module.exports = __webpack_public_path__ + "img/404.e39d81d5.png";